import * as types from "../../common/state/actionTypes";

export function setCurrentUser(user) {
  return { type: types.SET_CURRENT_USER, user };
}
